import { useMemo } from "react";
import { useSamplingProcedure } from "../../../../lib/servicesGenericsTables/useProcedure";
import { useFormContext } from "react-hook-form";
import { useAnalysisTypes } from "@services/servicesGenericsTables";
import { useParams } from "react-router-dom";
import { useSample } from "../utils/useSample";

const mapReferencia: Record<string, string> = {
  PRE: "cpr",
  CON: "cco",
  CAL: "cca",
  AA: "cmk",
};

const useFilteredProcedures = (typeSuffix: "PRE" | "CON" | "CAL" | "AA", codop?: string) => {
  const { procedureList } = useSamplingProcedure();
  const { analysisTypeList } = useAnalysisTypes();
  const { get } = useSample();
  const { idMuestra } = useParams();
  const form = useFormContext();
  const idAnalysis = form.getValues("typeAnalysis").id;
  const codeTypeSuffix = mapReferencia[typeSuffix];
  const sample = get(Number(idMuestra));
  const codeSample = sample?.sample_type?.codigo;
  const findAnalysis = analysisTypeList.find(
    (analysis) => analysis.id === idAnalysis
  );

  let codeTypeSuffixWithAnalysis = findAnalysis
    ? findAnalysis[codeTypeSuffix]?.toUpperCase()
    : null;

  if( typeof codop != "undefined" ) codeTypeSuffixWithAnalysis = codop;
  const filteredProcedures = useMemo(() => {
    if (!codeSample || !codeTypeSuffixWithAnalysis) return [];
    return procedureList.filter((procedure) => {
      return (
        procedure.codigo?.toUpperCase() === codeSample?.toUpperCase() &&
        codeTypeSuffixWithAnalysis.includes(procedure.codop?.toUpperCase())
      );
    });
  }, [procedureList, codeSample, codeTypeSuffixWithAnalysis]);

  return filteredProcedures;
};

export default useFilteredProcedures;
